import { Account } from "model/IChat";
import { ExperienceSource } from "model/IExperience";
import Trip from "model/ITrip";
import { Experiment } from "~context/ExperimentsContext/reducer/model";

const whenIdle = window.requestIdleCallback
  ? window.requestIdleCallback
  : (callback) => setTimeout(callback, 100);

export class BusinessEvent {
  type = 'BusinessEvent';
  traffic_type?: string;
  account_is_host?: boolean;
  account_id?: string;
  experiments?: Experiment[];
}
export class PageView extends BusinessEvent {
  type = 'PageView';
  title: string;
  name: string;
  location: string;
  path: string;
  search: string;
}

export class SearchPageViewed extends PageView {
  type = 'SearchPageViewed';
  city: string;
  category?: string;
}

export class Click extends BusinessEvent {
  type = 'Click';
  target: string;
}

export class CookieConsentUpdate extends BusinessEvent {
  type = 'CookieConsentUpdate';
  functional: boolean;
  analytics: boolean;
  advertisement: boolean;
  social: boolean;
  location: boolean;
}

export class ActionPointModalButtonClicked extends BusinessEvent {
  type = 'ActionPointModalButtonClicked';
  pathname: string;
}

export class ExperienceRelatedEvent extends BusinessEvent {
  type = 'ExperienceRelatedEvent';
  experience: Partial<ExperienceSource>;
  nrOfAdults?: number;
  nrOfChildren?: number;
  host?: Partial<Account>;
  date?: string;
  time?: string;
  position?: number;
  analyticsListName?: string;
}
export class ExperiencePageViewed extends ExperienceRelatedEvent {
  type = 'ExperiencePageViewed';
}
export class ExperienceCardViewed extends ExperienceRelatedEvent {
  type = 'ExperienceCardViewed';
}
export class ExperienceCardClicked extends ExperienceRelatedEvent {
  type = 'ExperienceCardClicked';
}
export class LandingPageRelatedEvent extends BusinessEvent {
  type = 'LandingPageRelatedEvent';
  buttonText: string;
}

export class LandingPageAboutWithlocalsOpen extends LandingPageRelatedEvent {
  type = 'LandingPageAboutWithlocalsOpen';
}

export class ContactHostFormEvent extends BusinessEvent {
  type = 'ContactHostFormRelatedEvent';
  experience?: Partial<ExperienceSource>;
  host?: Partial<Account>;
  enabledForm: string;
  source: string;
}

export class ContactHostFormViewed extends ContactHostFormEvent {
  type = 'ContactHostFormViewed';
}

export class ContactHostFormSent extends ContactHostFormEvent {
  type = 'ContactHostFormSent';
  nrOfAdults?: number;
  nrOfChildren?: number;
  date?: string;
  time?: string;
}

export class CheckoutProcessEvent extends BusinessEvent {
  type = 'CheckoutProcessEvent';
  trip?: Partial<Trip>;
  experience?: Partial<ExperienceSource>;
  nrOfAdults?: number;
  nrOfChildren?: number;
  host?: Partial<Account>;
  date?: string;
  time?: string;
  variant?: string;
} 
export class HostSelected extends CheckoutProcessEvent {
  type = 'HostSelected';
}
export class DateSelected extends CheckoutProcessEvent {
  type = 'DateSelected';
}
export class TimeSelected extends CheckoutProcessEvent {
  type = 'TimeSelected';
}
export class NumberOfGuestsSelected extends CheckoutProcessEvent {
  type = 'NumberOfGuestsSelected';
}
export class PaymentOptionSelected extends CheckoutProcessEvent {
  type = 'PaymentOptionSelected';
}
export class CheckoutPageViewed extends CheckoutProcessEvent {
  type = 'CheckoutPageViewed';
}
export class BookButtonClicked extends CheckoutProcessEvent {
  type = 'BookButtonClicked';
}
export class PaymentFormType extends CheckoutProcessEvent {
  type = 'PaymentFormType';
}

export class TripRelatedEvent extends BusinessEvent {
  type = 'TripRelatedEvent';
  trip: Partial<Trip>;
  payment_id?: string;
}
export class BookingConfirmed extends TripRelatedEvent {
  type = 'BookingConfirmed';
}

export type BusinessEventHandler = (event: BusinessEvent) => void;

export class BusinessEventSource {
  private _listeners: BusinessEventHandler[] = [];
  register = (listener: BusinessEventHandler) => {
    this._listeners.push(listener);
  };
  emit = (event: BusinessEvent | PageView) => {
    this._listeners.forEach((listener) =>
      whenIdle(() => {
        try {
          listener(event);
        } catch (error) {
          console.error("[trekker] Error in business event handler", event);
        }
      })
    );
  };
}
